<script lang="ts">
  import { questionnaire } from "../stores/questionnaire";
  import {questionnaireValidation} from "../stores/validation";
  import { onMount } from "svelte";
  import { t } from "../stores/translations";

  export let slug: string;
  let isValid = false;
  let binding = null as null|HTMLElement;

  onMount(() => {
    questionnaireValidation.addHTMLElement(slug, binding)
  });

  $: {
    const validationQuestion = $questionnaire.activeQuestions.find(x => x.slug === slug);

    isValid = validationQuestion ? !!validationQuestion.selectedAnswer : false;
  }
</script>

<div class="validation-container">
  <div class="scroll-anchor" bind:this={binding}></div>

  {#if !isValid && $questionnaireValidation.active}
    <span>{ $t(`questions.validation.required`) }</span>
  {/if}
</div>

<style lang="scss">
  @import "src/lib/styles/variables.scss";

  .scroll-anchor{
    position: absolute;
    top: -40px;
  }

  .validation-container {
    position: relative;

    span {
      font-family: "Roboto";
      font-weight: 400;
      font-size: 14px;
      color: $color-error-red;
      display: block;
      margin-bottom: 10px;
    }
  }
</style>